import { AfterViewInit, Component, input, model, OnChanges, OnInit, output, viewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgSelectComponent } from '@ng-select/ng-select'
import { isEqual } from 'lodash'
import { acquireFocusDelay } from './idr-filter-value.component'

@Component({
  selector: 'app-idr-multiselect',
  imports: [
    NgSelectComponent,
    FormsModule,
  ],
  template: `
    <ng-select
        [items]="options()"
        [multiple]="true"
        [hideSelected]="true"
        [closeOnSelect]="false"
        [(ngModel)]="model"
    >
    </ng-select>
  `,
})
export class IdrMultiselectFilterComponent implements OnInit, OnChanges, AfterViewInit {
  readonly options = input.required<readonly string[]>()
  readonly value = input.required<string>()
  readonly grabFocus = input.required<boolean>()

  readonly update = output<string>()

  protected readonly model = model<readonly string[]>([])
  private readonly selectRef = viewChild.required(NgSelectComponent)

  ngOnInit() {
    this.model.subscribe(newValue => {
      this.update.emit(newValue.join(','))
    })
  }

  ngOnChanges() {
    this.refreshModel()
  }

  ngAfterViewInit(): void {
    if (this.grabFocus()) {
      window.setTimeout(() => this.acquireFocus(), acquireFocusDelay)
    }
  }

  private acquireFocus() {
    this.selectRef().focus()
    this.selectRef().open()
  }

  private refreshModel() {
    const values = this.value().split(',').filter(Boolean)
    if (!isEqual(values, this.model())) {
      this.model.set(values)
    }
  }
}